import React, { useContext, useEffect, useState } from 'react';
import { oneOfType, string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Reviews } from './Reviews';

export const ReviewsContainer = ({ timeout, ...props }) => {
  const { channel } = useContext(ExperienceContext);
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const defaultVariables = {
    lat: '',
    lng: '',
    pagesize: '10',
    storeFeaturesFilter: {
      applianceShowroom: false,
      expandedFlooringShowroom: false,
      wiFi: false,
      keyCutting: false,
      loadNGo: false,
      propane: false,
      toolRental: false,
      penske: false
    },
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  const queryOptions = ({ options, queryName }) => {

    if (queryName === 'storeSearch') {
      return {
        ...options,
        variables: {
          ...options.variables,
          pagesize: '10',
        },
      };
    }

    return options;
  }

  return (
    <QueryProvider
      queryOptions={queryOptions}
      cacheKey={`store-reviews-${channel}`}
      defaultVariables={defaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Reviews {...props} />
    </QueryProvider>
  );
};

ReviewsContainer.propTypes = {
  timeout: oneOfType([string, number])
};

ReviewsContainer.defaultProps = {
  timeout: '3000'
};
